import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function authHeaders () {
  return { Authorization: store.getters.getTokenId }
}

function buildSearchParams ({
  recipient,
  messageStatus,
  messageType,
  dateFrom,
  dateTo,
  orderBy,
  sortOrder,
  page,
  limit
}) {
  const params = {}

  if (recipient) {
    params.recipient = recipient
  }
  if (messageStatus && messageStatus.length) {
    params.messageStatus = Array.isArray(messageStatus) ? messageStatus.join(',') : messageStatus
  }
  if (messageType && messageType.length) {
    params.messageType = Array.isArray(messageType) ? messageType.join(',') : messageType
  }
  if (dateFrom) {
    params.dateFrom = dateFrom
  }
  if (dateTo) {
    params.dateTo = dateTo
  }
  if (orderBy) {
    params.orderBy = orderBy
  }
  if (sortOrder) {
    params.sortOrder = sortOrder
  }
  if (page) {
    params.page = page
  }
  if (limit) {
    params.limit = limit
  }

  return params
}

function searchMessageQueue (options) {
  return apiRequests.get('/v1/message-queue/search/', {
    params: buildSearchParams(options),
    headers: authHeaders()
  }).then(function (result) {
    return result.data
  })
}

function countMessageQueue (options) {
  return apiRequests.get('/v1/message-queue/count/', {
    params: buildSearchParams(options),
    headers: authHeaders()
  }).then(function (result) {
    return result.data && typeof result.data.count === 'number' ? result.data.count : 0
  })
}

function getMessageQueueById (id) {
  return apiRequests.get('/v1/message-queue/' + id + '/', {
    headers: authHeaders()
  }).then(function (result) {
    return result.data
  })
}

export {
  searchMessageQueue,
  countMessageQueue,
  getMessageQueueById
}
